import styled from 'styled-components'

export const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 64px);
  overflow: hidden;
`
